/* ============================================================
   BOTANILABS — Navigation drawer behaviour (open/close/accordion).
   Loaded via <script defer> from snippets/botani-menu-drawer.liquid.
   Accessible: Escape closes, focus moves to close button,
   aria-expanded on accordions. Delegated where possible.
   ============================================================ */
(function () {
  function init() {
    var root = document.querySelector('[data-bmenu-root]');
    if (!root) return;

    // Escape Dawn's header-group stacking context: move the whole drawer+overlay
    // to be a DIRECT child of <body> (like the cart drawer) so its fixed
    // positioning is viewport-relative and its z-index beats everything.
    // Remove any stale relocated copy first (the theme editor re-renders the section).
    document.querySelectorAll('body > [data-bmenu-root]').forEach(function (el) {
      if (el !== root) el.remove();
    });
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var drawer = root.querySelector('#BotaniMenuDrawer');
    if (!drawer || drawer.dataset.bound) return;
    drawer.dataset.bound = '1';

    var burger = document.querySelector('[data-bmenu-open]');
    var overlay = root.querySelector('[data-bmenu-overlay]');
    var closeBtn = drawer.querySelector('[data-bmenu-close]');

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (burger) burger.setAttribute('aria-expanded', 'true');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); }
    }

    if (burger) burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.querySelectorAll('[data-bmenu-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var sub = btn.nextElementSibling;
        drawer.querySelectorAll('[data-bmenu-acc][aria-expanded="true"]').forEach(function (other) {
          if (other !== btn) {
            other.setAttribute('aria-expanded', 'false');
            if (other.nextElementSibling) other.nextElementSibling.style.maxHeight = '';
          }
        });
        if (expanded) {
          btn.setAttribute('aria-expanded', 'false');
          if (sub) sub.style.maxHeight = '';
        } else {
          btn.setAttribute('aria-expanded', 'true');
          if (sub) sub.style.maxHeight = sub.scrollHeight + 'px';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
